export const CORE_STYLES = `

[data-string-devtools-overlay-badge][data-module-enabled="false"] {
  display: none;
}

[data-string-devtools-overlay-badge][data-visible="false"] {
  display: none;
}

[data-stdg] {
  --string-dg-font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
    'Helvetica Neue', sans-serif;
  --string-dg-font-size: 12px;
  --string-dg-font-size-s: 10px;
  --string-dg-font-size-xs: 8px;
  --string-dg-font-normal: 400;
  --string-dg-font-medium: 500;
  --string-dg-font-bold: 600;

  --string-dg-color-blue: #3687ff;
  --string-dg-color-amber: #b45100;
  --string-dg-color-green: #00823c;
  --string-dg-color-teal: #00788c;
  --string-dg-color-red: #f45524;
  --string-dg-color-black: #111111;
  --string-dg-color-white: #ffffff;
  --string-dg-color-cloud-white: rgba(249, 249, 249, 0.8);
  --string-dg-color-middle-white: rgba(249, 249, 249, 0.4);
  --string-dg-color-hairline: rgba(220, 220, 220, 0.5);
  --string-dg-color-offset: rgba(127, 127, 127, 0.8);
  --string-dg-color-grey-1: #eeeeee;
  --string-dg-color-grey-2: #dddddd;
  --string-dg-color-grey-3: #cccccc;
  --string-dg-color-grey-4: #bbbbbb;
  --string-dg-color-grey-5: #aaaaaa;
  --string-dg-color-grey-6: #888888;

  /* dock */
  --string-dg-dock-radius: 16px;
  --string-dg-dock-padding: 3px 4px;
  --string-dg-dock-shadow: 0 16px 32px rgba(0, 0, 0, 0.08);

  /* badge */
  --string-dg-badge-radius: 12px;
  --string-dg-badge-padding: 1px;
  --string-dg-badge-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

  /* panel */
  --string-dg-panel-radius: 18px;
  --string-dg-panel-padding: 0px;
  --string-dg-panel-shadow: 0 0 1px rgba(0, 0, 0, 0.4), 0 16px 32px rgba(0, 0, 0, 0.08);
  --string-dg-panel-header-padding: 5px;
  --string-dg-panel-responsive-margin: 0 5px 8px 5px;
  --string-dg-panel-conent-margin: 0 5px 8px 5px;
  --string-dg-panel-hr-margin: 16px 0;

  /* buttons | inputs | etc */
  --string-dg-min-height: 34px;

  /* input */
  --string-dg-input: 4px 0;
  --string-dg-input-container-negative-margin: -8px;
  --string-dg-input-range-padding: 6px 8px;
  --string-dg-panel-range-width: 2px;
  --string-dg-input-range-webkit-margin: 4px;

  /* toggle */
  --string-dg-toggle-gap: 8px;
  --string-dg-toggle-knob: 12px;
  --string-dg-toggle-padding: 1px;
  --string-dg-toggle-radius: 12px;
  --string-dg-toggle-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);

  /* button */
  /* button | icon-20 */
  --string-dg-button-icon-20-background: rgba(255, 255, 255, 0.25);
  --string-dg-button-icon-20-radius: 12px;
  --string-dg-button-icon-20-padding: 6px;
  /* button | icon-16 */
  --string-dg-button-icon-16-background: rgba(255, 255, 255, 0.25);
  --string-dg-button-icon-16-radius: 10px;
  --string-dg-button-icon-16-padding: 5px;
  /* button | icon-12 */
  --string-dg-button-icon-12-background: rgba(255, 255, 255, 0.25);
  --string-dg-button-icon-12-radius: 5px;
  --string-dg-button-icon-12-margin: 1px;

  /* panel button */
  --string-dg-panel-button-radius: 8px;
  --string-dg-panel-button-padding-1: 8px;
  --string-dg-panel-button-padding-2: 8px 12px 8px 5px;
  --string-dg-panel-button-gap: 8px;

  /* panel field */
  --string-dg-panel-field-slider-gap: 4px;

  --string-dg-panel-field-padding: 0 0 0 8px;
  --string-dg-panel-field-input-padding: 8px 0;
  --string-dg-panel-field-icon-left: 5px;
  --string-dg-panel-field-label-left: 8px;

  /* panel breakpoints */
  --string-dg-panel-breakpoints-margin: 16px 0 24px;
  --string-dg-panel-breakpoint-marker-width: 2px;
  --string-dg-panel-breakpoint-marker-padding: 4px 8px 0px;
  --string-dg-panel-breakpoint-marker-margin: -4px -16px 0px;
  --string-dg-panel-breakpoints-span-pos-cor: 4px;

  /* panel-item */
  --string-dg-panel-list-item-radius: 8px;
  --string-dg-panel-list-item-padding: 8px 5px 8px 5px;
  --string-dg-panel-list-item-grabbing: -8px -5px -8px -5px;
  --string-dg-panel-list-item-delete-margin: -4px 0;

  /* offsets */
  --string-dg-offsets-dasharray: 2px 8px;

  font-family: var(--string-dg-font-family);
  font-size: var(--string-dg-font-size);
  line-height: 1;
  color: var(--string-dg-color-black);
  box-sizing: content-box;
  box-shadow: none;
  background: none;
  border: none;
  border-radius: 0;
}

/* input */


[data-stdg-input], [data-stdg-input]:focus, [data-stdg-input]:hover {
  box-shadow: none !important;
  background-color: none;
  background-image: none;
  outline: none;
  border: none;
  color: none;
  -webkit-box-shadow: none !important;
}

input[type=number] {
  -moz-appearance:textfield; /* Firefox */
}
  

[data-stdg-input][type='color'] {
  display: flex;
  justify-content: center;
  
}

input[type="color" i]::-webkit-color-swatch-wrapper {
  padding: 0;
  height: 50%;
  width: 50%;
  aspect-ratio: 1/1;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid var(--string-dg-color-white);
}

input[type="color" i]::-webkit-color-swatch{
border: none;
}

[data-stdg-input][type='color']::-moz-color-swatch {
  padding: 0;
  height: 50%;
  width: 50%;
  aspect-ratio: 1/1;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid var(--string-dg-color-white);
}
[data-stdg-input][type='number'] {
  font-variant-numeric: tabular-nums;
}
[data-stdg-select],
[data-stdg-select]::-webkit-outer-spin-button,
[data-stdg-select]::-webkit-inner-spin-button,
[data-stdg-input][type='number']::-webkit-outer-spin-button,
[data-stdg-input][type='number']::-webkit-inner-spin-button {
  -moz-appearance: textfield;
  -webkit-appearance: none;
  margin: 0;
}
[data-stdg-input][type="range"] {
  -webkit-appearance: none;
  appearance: none;
  align-items: stretch;
  width: 100%;
  display: inline-block;
  background: transparent;
  background-image: linear-gradient(
    to right,
    var(--string-dg-color-grey-2) var(--string-progress-slider-fill),
    transparent var(--string-progress-slider-fill)
  );
  border-radius: var(--string-dg-panel-button-radius);
}
[data-stdg-input][type="range"]::-moz-range-track {
  display: none;
}
[data-stdg-input][type="range"]::-moz-range-thumb {
  appearance: none;
  width: 0;
  height: 100%;
  border: none;
  padding: var(--string-dg-input-range-padding);
  background: none;
  background-image:
    linear-gradient(0deg, var(--string-dg-color-black))
  ;
  background-repeat: no-repeat;
  background-size: var(--string-dg-panel-breakpoint-marker-width) 100%;
  background-position: center center;
  cursor: col-resize;
}
[data-stdg-input][type="range"]::-webkit-slider-container {
  margin-top: calc(-1.5 * var(--string-dg-input-range-webkit-margin));
  height: calc(100% + var(--string-dg-input-range-webkit-margin) * 3);

  margin-left: var(--string-dg-input-container-negative-margin);
  margin-right: var(--string-dg-input-container-negative-margin);
}
[data-stdg-input][type="range"]::-webkit-slider-runnable-track {
  height: 100%;
}
[data-stdg-input][type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 0;
  height: 100%;
  padding: var(--string-dg-input-range-padding);
  background-image:
    linear-gradient(0deg, var(--string-dg-color-black))
  ;
  background-repeat: no-repeat;
  background-size: var(--string-dg-panel-range-width) 100%;
  background-position: center center;
  cursor: col-resize;

  opacity: 0;
  transition: opacity 0.15s ease-out;
}
[data-stdg-input][type="range"]:hover::-webkit-slider-thumb,
[data-stdg-input][type="range"]:active::-webkit-slider-thumb {
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

[data-stdg-select],
[data-stdg-input],
[data-stdg-textarea] {
  display: block;
  width: 100%;
  box-sizing: content-box;
  background-color: transparent;
  padding: var(--string-dg-input);
  margin: 0;
  border-radius: 0;
  border: none;
  box-shadow: none;
  text-align: center;
  text-align-last: center;
  cursor: default;

  font-family: var(--string-dg-font-family);
  font-size: var(--string-dg-font-size-s);
  font-weight: var(--string-dg-font-bold);
}
[data-stdg-select]:focus,
[data-stdg-input]:focus,
[data-stdg-textarea]:focus {
  outline: none;
  box-shadow: none;
}

/* toggle */
[data-stdg-toggle] {
  border-radius: var(--string-dg-toggle-radius);
  background: var(--string-dg-color-grey-3);
  padding: var(--string-dg-toggle-padding) calc(var(--string-dg-toggle-gap) + var(--string-dg-toggle-padding))
    var(--string-dg-toggle-padding) var(--string-dg-toggle-padding);
  display: inline-flex;
  position: relative;
}
[data-stdg-toggle-input] {
  display: none;
}
[data-stdg-toggle-knob] {
  width: var(--string-dg-toggle-knob);
  height: var(--string-dg-toggle-knob);
  border-radius: var(--string-dg-toggle-radius);
  background: var(--string-dg-color-white);
  box-shadow: var(--string-dg-toggle-shadow);
  margin-left: auto;
}
[data-stdg-toggle][data-checked='true'] {
  background-color: var(--string-dg-color-blue);
}
[data-checked='false'] [data-stdg-toggle-knob] {
  translate: var(--string-dg-toggle-gap) 0;
}

/* button */

[data-stdg-panel-content] > [data-stdg-panel-breakpoints],
[data-stdg-panel-field-slider] > [data-stdg-panel-field],
[data-stdg-panel-content] > [data-stdg-panel-field],
[data-stdg-panel-content] > [data-stdg-button] {
  min-height: var(--string-dg-min-height);
}

[data-stdg-panel-breakpoints],
[data-stdg-panel-field],
[data-stdg-button] {
  display: flex;
  box-shadow: none;
  background: none;
  border-radius: 0;
  margin: 0;
  padding: 0;
  cursor: default;
  box-sizing: border-box;
  border: 1px solid transparent;
  font-family: var(--string-dg-font-family);
  font-size: var(--string-dg-font-size);
  font-weight: var(--string-dg-font-medium);
  color: var(--string-dg-color-black);
}
[data-stdg-panel-field][data-disabled="true"]{
  display: none;
}
[data-stdg-dock-list] > [data-stdg-button] {
  display: block;
}
[data-stdg-panel-breakpoints] > *,
[data-stdg-panel-field] > *,
[data-stdg-button] > * {
  grid-area: 1/1;
  flex-shrink: 0;
}
[data-stdg-panel-breakpoints] span,
[data-stdg-panel-field] span,
[data-stdg-button] span {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
/* button | icon-20 */
[data-stdg-holder-icon-20] {
  padding: var(--string-dg-button-icon-20-padding);
}
[data-stdg-button-icon-20] {
  background-color: var(--string-dg-button-icon-20-background);
  padding: var(--string-dg-button-icon-20-padding);
  border-radius: var(--string-dg-button-icon-20-radius);
}
[data-stdg-icon-20] {
  width: 20px;
  aspect-ratio: 1/1;
  color: var(--string-dg-color-black);
}
/* button | icon-16 */
[data-stdg-holder-icon-16] {
  padding: var(--string-dg-button-icon-16-padding);
}
[data-stdg-button-icon-16] {
  background-color: var(--string-dg-button-icon-16-background);
  padding: var(--string-dg-button-icon-16-padding);
  border-radius: var(--string-dg-button-icon-16-radius);
}
[data-stdg-icon-16] {
  width: 16px;
  aspect-ratio: 1/1;
  color: var(--string-dg-color-black);
}
/* button | icon-12 */
[data-stdg-holder-icon-12] {
}
[data-stdg-button-icon-12] {
  background-color: var(--string-dg-button-icon-12-background);
  border-radius: var(--string-dg-button-icon-12-radius);
  margin: var(--string-dg-button-icon-12-margin);
}
[data-stdg-icon-12] {
  width: 12px;
  aspect-ratio: 1/1;
  color: var(--string-dg-color-black);
}
/* button | icon-second */
[data-stdg-icon-second] {
  color: var(--string-dg-color-grey-4);
}
/* button | hover */
[data-stdg-button-hover] {
  display: grid;
  place-items: center;
}
[data-stdg-button-hover] svg:last-child {
  visibility: hidden;
}
[data-stdg-button-hover]:hover svg:first-child {
  visibility: hidden;
}
[data-stdg-button-hover]:hover svg:last-child {
  visibility: visible;
}
[data-stdg-dock] [data-stdg-button-hover] svg:last-child {
  transform: rotate(-90deg);
}
[data-stdg-dock] [data-stdg-button-hover][data-collapsed='true'] svg:last-child {
  transform: rotate(90deg);
}

/* button | data-active */
[data-active='false'] [data-stdg-icon-12],
[data-active='false'] [data-stdg-icon-16],
[data-active='false'] [data-stdg-icon-20] {
  color: var(--string-dg-color-grey-5);
}
/* button | toggle */
[data-stdg-button-toggle][data-active='false'] [data-stdg-icon-12]:not([data-stdg-icon-second]),
[data-stdg-button-toggle][data-active='false'] [data-stdg-icon-16]:not([data-stdg-icon-second]),
[data-stdg-button-toggle][data-active='false'] [data-stdg-icon-20]:not([data-stdg-icon-second]) {
  color: var(--string-dg-color-black);
}
[data-stdg-button-toggle][data-active='true'] {
  background-color: var(--string-dg-color-grey-2);
}
  
[data-stdg-button-toggle][data-active='true'] [data-stdg-icon-12]:not([data-stdg-icon-second]),
[data-stdg-button-toggle][data-active='true'] [data-stdg-icon-16]:not([data-stdg-icon-second]),
[data-stdg-button-toggle][data-active='true'] [data-stdg-icon-20]:not([data-stdg-icon-second]) {
  
}

[data-stdg-panel-breakpoints]:hover:not([data-stdg-panel-breakpoint-marker]):not([data-string-grid-list-delete]),
[data-stdg-panel-field]:hover:not([data-stdg-panel-breakpoint-marker]):not([data-string-grid-list-delete]),
[data-stdg-button]:hover:not([data-stdg-panel-breakpoint-marker]):not([data-string-grid-list-delete]) {
  border: 1px solid var(--string-dg-color-cloud-white);
  background-color: var(--string-dg-color-grey-1);
}
[data-stdg-button]:active:not(:has([data-stdg-toggle]:active)):not([data-stdg-panel-breakpoint-marker]) {
  border: 1px solid var(--string-dg-color-cloud-white);
  background-color: var(--string-dg-color-grey-3);
}

/* panel button */
[data-stdg-panel-button] {
  box-sizing: border-box;
  border: 1px solid var(--string-dg-color-white);
  background-color: var(--string-dg-color-grey-1);

  border-radius: var(--string-dg-panel-button-radius);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--string-dg-panel-button-gap);
}
[data-stdg-panel-button]:has(svg):has(span) {
  width: 100%;
  padding: var(--string-dg-panel-button-padding-2);
}
[data-stdg-panel-button]:not(:has(svg):has(span)) {
  background-color: var(--string-dg-color-white);
  padding: var(--string-dg-panel-button-padding-1);
}

[data-stdg-panel-button]:not(:has(svg):has(span)) span {
  font-size: var(--string-dg-font-size-s);
  font-weight: var(--string-dg-font-bold);
  width: 16px;
  aspect-ratio: 1/1;
  display: grid;
  place-items: center;
}
[data-stdg-panel-button][data-active='true']:not(:has(svg):has(span)) span {
}

[data-string-grid-list-delete] {
  background-color: var(--string-dg-color-white);
  border-radius: 50%;
}


/* panel list-item */
[data-stdg-panel-list-item] {
  border: 1px solid var(--string-dg-color-white);
  background-color: var(--string-dg-color-grey-1);

  border-radius: var(--string-dg-panel-list-item-radius);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--string-dg-panel-button-gap);

  padding: var(--string-dg-panel-list-item-padding);
}
[data-stdg-panel-list-item] [data-stdg-icon-second] {
  padding: var(--string-dg-panel-list-item-padding);
  margin: var(--string-dg-panel-list-item-grabbing);
}
[data-stdg-panel-list-item] [data-stdg-icon-second]:active {
  cursor: grabbing;
}
[data-stdg-panel-list-item] > span {
  margin-right: auto;
}
[data-stdg-panel-list-item] [data-stdg-toggle] {
}
[data-stdg-panel-list-item] [data-string-grid-list-delete] {
  margin: var(--string-dg-panel-list-item-delete-margin);
}
[data-stdg-panel-list-item][data-dragging="true"] {
  opacity: 0.4;
  cursor: grabbing;
}
[data-stdg-panel-list-item][data-drag-over="before"] {
  box-shadow: 0 -2px 0 var(--string-dg-color-black);
}
[data-stdg-panel-list-item][data-drag-over="after"] {
  box-shadow: 0 2px 0 var(--string-dg-color-black);
}

[data-stdg-panel-list-item]:has([data-checked='false']) > [data-stdg-icon-16] {
  color: var(--string-dg-color-grey-4) !important;
}
[data-stdg-panel-list-item]:has([data-checked='false']) > span {
  color: var(--string-dg-color-grey-6);
}

/* panel field */
[data-stdg-panel-field] {
  box-sizing: border-box;
  border: 1px solid var(--string-dg-color-white);
  background-color: var(--string-dg-color-grey-1);

  border-radius: var(--string-dg-panel-button-radius);
  padding: var(--string-dg-panel-field-padding);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--string-dg-panel-button-gap);
}
[data-stdg-panel-field]:has(> [data-stdg-field-input-disable]) {
  padding: 0;
  gap: 0;
}

[data-stdg-panel-field]:has(> [data-stdg-toggle]:last-child) {
  padding-right: 8px;
}

[data-stdg-panel-field] span {
}

[data-stdg-field-input] {
  width: 50%;
  display: flex;
  align-items: center;
}
[data-stdg-field-input] > * {
  flex: 1;
}
[data-stdg-field-value] {
  display: flex;
  align-items: center;
  min-width: 0;
}
[data-stdg-field-value] [data-stdg-input] {
  flex: 1;
  min-width: 0;
}
[data-stdg-field-suffix] {
  flex: 0 0 auto;
  padding: var(--string-dg-panel-field-input-padding);
  color: var(--string-dg-color-grey-6);
  font-size: var(--string-dg-font-size-s);
  font-weight: var(--string-dg-font-bold);
  background-image: linear-gradient(0deg, var(--string-dg-color-grey-3));
  background-repeat: no-repeat;
  background-size: 1px 80%;
  background-position: left center;
}
[data-stdg-field-input] [data-stdg-select],
[data-stdg-field-input] [data-stdg-input] {
  padding: var(--string-dg-panel-field-input-padding);
  background-image: linear-gradient(0deg, var(--string-dg-color-grey-3));
  background-repeat: no-repeat;
  background-size: 1px 80%;
  background-position: left center;
}
[data-stdg-field-input] [data-stdg-input][type='color'] {
  flex: 0 0 33.3333%;
  height: 100%;
}
[data-stdg-field-input] [data-stdg-stepper] {
  flex: 0 0 33.3333%;
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
  align-items: stretch;
  background-image: linear-gradient(0deg, var(--string-dg-color-grey-3)), linear-gradient(0deg, var(--string-dg-color-grey-3));
  background-repeat: no-repeat, no-repeat;
  background-size:
    1px 80%,
    90% 1px;
  background-position:
    left center,
    left center;
}
[data-stdg-field-input] [data-stdg-stepper] button {
  width: 100%;
  display: grid;
  place-items: center;
}

/* svg + input + px */
[data-stdg-panel-field] > span > [data-stdg-icon-16] {
  position: absolute;
  top: 8px;
  left: var(--string-dg-panel-field-icon-left);
  pointer-events: none;
}
[data-stdg-panel-field] > [data-stdg-icon-16] {
  position: absolute;
  left: var(--string-dg-panel-field-icon-left);
  pointer-events: none;
}
[data-stdg-panel-field] > input {
  align-self: stretch;
  flex: 1;
}
[data-stdg-panel-field]:has(> [data-stdg-icon-16]) > input {
  padding-left: var(--string-dg-panel-field-icon-left);
}
[data-stdg-field-input-disable] {
  flex: 0 0 16%;
  min-width: calc(var(--string-dg-font-size) * 3);
  text-align: center;
  color: var(--string-dg-color-grey-6);
  padding: var(--string-dg-panel-field-input-padding);
  background-image: linear-gradient(0deg, var(--string-dg-color-grey-3));
  background-repeat: no-repeat;
  background-size: 1px 80%;
  background-position: left center;
}

/* slider wrapper */
[data-stdg-panel-field-slider-row] {
  display: flex;
  gap: var(--string-dg-panel-field-slider-gap);
}
[data-stdg-panel-field-slider-row] [data-stdg-panel-field] {
  flex: 0 0 20%;
}
[data-stdg-panel-field-slider-row] [data-stdg-panel-field-slider] {
  flex: 1;
  padding: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
[data-stdg-panel-field-slider] label {
  position: absolute;
  left: var(--string-dg-panel-field-label-left);
  color: var(--string-dg-color-grey-6);
  pointer-events: none;
}
[data-stdg-panel-field-slider] input {
  grid-area: 1/1;
  justify-self: stretch;
  min-width: 0;
  width: 100%;
}

/* panel responsive */
[data-stdg-panel-breakpoints] {
  box-sizing: border-box;
  border: 1px solid var(--string-dg-color-white);
  background-color: var(--string-dg-color-grey-1);

  border-radius: var(--string-dg-panel-button-radius);

  margin: var(--string-dg-panel-breakpoints-margin);

  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: var(--string-dg-panel-button-gap);

  font-size: var(--string-dg-font-size-s);
  font-weight: var(--string-dg-font-bold);
}
[data-stdg-panel-breakpoints]:before {
  content: '0';
  font-size: var(--string-dg-font-size-xs);
  color: var(--string-dg-color-grey-3);
  position: absolute;
  bottom: calc(100% + var(--string-dg-font-size-xs) / 2 + var(--string-dg-panel-breakpoints-span-pos-cor));
}
[data-stdg-panel-breakpoint-value] {
  flex: 1;
  display: grid;
  place-items: center;
  text-align: center;
}
[data-stdg-panel-breakpoint-value] > * {
  grid-area: 1/1;
}
[data-stdg-panel-breakpoint-value] [data-string-grid-list-delete] {
  visibility: hidden;
}
[data-stdg-panel-breakpoint-value]:hover [data-string-grid-list-delete] {
  visibility: visible;
}

[data-stdg-panel-breakpoint-marker] {
  align-self: stretch;
  position: relative;
  display: flex;
  justify-content: center;
  padding: var(--string-dg-panel-breakpoint-marker-padding);
  margin: var(--string-dg-panel-breakpoint-marker-margin);
  background-image: linear-gradient(0deg, var(--string-dg-color-black));
  background-repeat: no-repeat;
  background-size: var(--string-dg-panel-breakpoint-marker-width) 100%;
  background-position: center center;
}
[data-stdg-panel-breakpoint-marker]::before,
[data-stdg-panel-breakpoint-marker]::after {
  content: '';
  position: absolute;
  top: 100%;
  width: 100%;
  padding-bottom: 100%;
}
[data-stdg-panel-breakpoint-marker]::after {
  border-radius: 50%;
  background-color: var(--string-dg-color-black);
  transform-origin: 50% 0%;
  scale: 0.5;
}
[data-stdg-panel-breakpoint-marker] span {
  font-size: var(--string-dg-font-size-xs);
  color: var(--string-dg-color-grey-6);
  position: absolute;
  bottom: calc(100% + var(--string-dg-font-size-xs) / 2);
}
[data-stdg-panel-breakpoint-marker]:hover span {
  color: var(--string-dg-color-black);
}
[data-stdg-panel-breakpoint-marker][data-active='true']::after {
  scale: 1;
}
[data-stdg-panel-breakpoints] [data-stdg-panel-breakpoint-value]:first-child {
  border-radius: var(--string-dg-panel-button-radius);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[data-stdg-panel-breakpoints] [data-stdg-panel-breakpoint-value]:last-child {
  border-radius: var(--string-dg-panel-button-radius);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[data-stdg-panel-breakpoint-value]:has(+ [data-active='true']),
[data-stdg-panel-breakpoint-marker][data-active='true'] + div {
  background-color: var(--string-dg-color-grey-3);
}

/* dock */
[data-stdg-dock] {
  position: fixed;
  z-index: 10035;
  bottom: 24px;
  left: 124px;

  display: flex;
  flex-direction: row;
  align-items: center;

  background-color: var(--string-dg-color-cloud-white);
  padding: var(--string-dg-dock-padding);
  border: 1px solid var(--string-dg-color-middle-white);
  border-radius: var(--string-dg-dock-radius);
  box-shadow: var(--string-dg-dock-shadow);

  backdrop-filter: blur(4px);
}
[data-stdg-dock-list] {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  overflow: visible;
}
[data-stdg-dock-tools] {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: visible;
  opacity: 1;
  transition:
    max-width 0.22s ease,
    opacity 0.16s ease;
}
[data-stdg-dock][data-collapsed="true"] [data-stdg-dock-tools] {
  overflow: hidden;
}
[data-stdg-dock-fps-separator] {
  display: block;
}
[data-stdg-dock] > [data-stdg-button] {
  align-self: center;
}
[data-string-defguides-doc-fps] {
  display: grid;
  place-items: center;
  aspect-ratio: 1/1;
  padding: var(--string-dg-button-icon-20-padding);
}
[data-string-defguides-doc-fps] span {
  grid-area: 1/1;
  width: 20px;
  text-align: center;
  vertical-align: middle;
  cursor: default;
}
[data-stdg-horizontal-line] {
  align-self: stretch;
  display: block;
  width: 0px;
  margin: 0 4px;
  border-right: 1px solid var(--string-dg-color-hairline);
}

/* dock sub-badges */
[data-stdg-dock-slot] {
  position: relative;
  display: flex;
  align-items: center;
  overflow: visible;
}
[data-stdg-dock-slot][data-has-sub-badges]::after {
  content: "";
  position: absolute;
  left: -4px;
  right: -4px;
  bottom: 100%;
  height: 8px;
  pointer-events: auto;
}
[data-stdg-dock-sub-badges] {
  position: fixed;
  display: flex;
  flex-direction: row;
  gap: 4px;
  white-space: nowrap;
  padding: var(--string-dg-badge-padding);
  background-color: var(--string-dg-color-cloud-white);
  border: 1px solid var(--string-dg-color-middle-white);
  border-radius: var(--string-dg-badge-radius);
  box-shadow: var(--string-dg-badge-shadow);
  backdrop-filter: blur(4px);
  opacity: 0;
  pointer-events: none;
  z-index: 10034;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: manipulation;
  transform: translate(-50%, calc(100% + 16px));
  transition: transform .3s, opacity .3s;
}
[data-stdg-dock-sub-badge] {
  position: relative;
}
[data-stdg-dock-sub-badge][data-parent-active="false"] [data-stdg-icon-12],
[data-stdg-dock-sub-badge][data-parent-active="false"] [data-stdg-icon-16],
[data-stdg-dock-sub-badge][data-parent-active="false"] [data-stdg-icon-20] {
  color: var(--string-dg-color-grey-5);
}
[data-stdg-dock-sub-badge]::before {
  content: "";
  position: absolute;
  inset: -6px;
}
[data-stdg-dock-sub-badges][data-open="true"] {
  opacity: 1;
  transform: translate(-50%, 0);
  pointer-events: auto;
}

@media (max-width: 1024px), (pointer: coarse) {
  [data-stdg-dock] [data-stdg-button-hover] svg:last-child {
    transform: rotate(0deg);
  }

  [data-stdg-dock] [data-stdg-button-hover][data-collapsed='true'] svg:last-child {
    transform: rotate(180deg);
  }

  [data-stdg-dock] {
    top: 50%;
    bottom: auto;
    left: max(12px, env(safe-area-inset-left, 0px) + 12px);
    transform: translateY(-50%);
    max-height: calc(100vh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px));
    flex-direction: column;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    touch-action: manipulation;
  }

  [data-stdg-dock-list] {
    flex-direction: column;
  }

  [data-stdg-dock-tools] {
    flex-direction: column;
    transition:
      max-height 0.22s ease,
      opacity 0.16s ease;
  }

  [data-stdg-dock][data-collapsed="true"] [data-stdg-dock-tools] {
    overflow: hidden;
  }

  [data-stdg-horizontal-line] {
    width: auto;
    height: 0px;
    margin: 4px 0;
    border-right: none;
    border-top: 1px solid var(--string-dg-color-hairline);
  }

  [data-stdg-dock-slot][data-has-sub-badges]::after {
    left: 100%;
    right: auto;
    top: -4px;
    bottom: -4px;
    width: 8px;
    height: auto;
  }

  [data-stdg-dock-sub-badges] {
    flex-direction: column;
    transform: translate(8px, -50%);
  }

  [data-stdg-dock-sub-badges][data-open="true"] {
    transform: translate(0, -50%);
  }

  /* compact: panel width shrinks to fit narrow viewports */
  [data-stdg-panel] {
    width: min(280px, calc(100vw - 32px));
    max-width: calc(100vw - 32px);
  }

  [data-stdg-badge][data-mobile-sheet="true"] > [data-stdg-panel] {
    right: auto;
    height: auto;
    overflow: hidden auto;
    overscroll-behavior: contain;
  }

  [data-stdg-badge][data-mobile-sheet="true"] > [data-stdg-panel] > [data-stdg-panel] {
    position: static;
    display: none;
    inset: auto;
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow: hidden auto;
    overscroll-behavior: contain;
    box-shadow: none;
    transform: none;
  }

  [data-stdg-badge][data-mobile-sheet="true"] > [data-stdg-panel]:has(> [data-stdg-panel][data-open="true"]) > :not([data-stdg-panel]) {
    display: none;
  }

  [data-stdg-badge][data-mobile-sheet="true"] > [data-stdg-panel] > [data-stdg-panel][data-open="true"] {
    display: block;
  }

  /* panel detached to body as fixed element in mobile mode */
  [data-stdg-panel][data-mobile-sheet="true"] {
    z-index: 10045;
    overflow: hidden auto;
    overscroll-behavior: contain;
  }

  [data-stdg-panel][data-mobile-sheet="true"] > [data-stdg-panel] {
    position: static;
    display: none;
    inset: auto;
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow: hidden auto;
    overscroll-behavior: contain;
    box-shadow: none;
    transform: none;
  }

  [data-stdg-panel][data-mobile-sheet="true"]:has(> [data-stdg-panel][data-open="true"]) > :not([data-stdg-panel]) {
    display: none;
  }

  [data-stdg-panel][data-mobile-sheet="true"] > [data-stdg-panel][data-open="true"] {
    display: block;
  }

  /* compact: progress floating panel */
  [data-stdg-progress] {
    bottom: max(16px, env(safe-area-inset-bottom, 0px) + 16px);
    max-height: calc(100vh - 32px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px));
  }
}

/* badge */
[data-stdg-badge] {
  position: absolute;
  z-index: 10030;
  top: 0;
  left: 0;
  width: auto;
  padding-bottom: auto;

  display: flex;
  pointer-events: auto;

  background-color: var(--string-dg-color-cloud-white);
  padding: var(--string-dg-badge-padding);
  border: 1px solid var(--string-dg-color-middle-white);
  border-radius: var(--string-dg-badge-radius);
  box-shadow: var(--string-dg-badge-shadow);
}

[data-dragging-active] [data-stdg-badge]:not([data-dragging]) {
  opacity: 0;
  pointer-events: none;
}

[data-stdg-badge][data-test-progress] {
  left: 62px;
}
[data-stdg-badge][data-test-layout] {
  position: fixed;
  top: 200px;
  left: auto;
  right: 100px;
}
[data-stdg-badge][data-visible="false"] {
  display: none;
}

[data-stdg-button]:has([data-stdg-badge-label]) {
  flex-direction: column;
  align-items: center;
}
[data-stdg-button]:has([data-stdg-badge-label]) svg {
  transform: translateY(-25%);
}
[data-stdg-button]:has([data-stdg-badge-label]) > :not([data-stdg-badge-label]) {
  grid-area: unset;
}
[data-stdg-badge-label] {
  grid-area: unset;
  font-size: var(--string-dg-font-size-xs);
  line-height: 0;
  text-align: center;
  color: var(--string-dg-color-black);
  pointer-events: none;
  user-select: none;
  // margin-bottom: -0.4em;
  white-space: nowrap;
  font-weight: var(--string-dg-font-bold);
  width: 0;
  display: flex;
  justify-content: center;
}

/* panel */
[data-stdg-panel] {
  position: absolute;

  width: 220px;
  background-color: var(--string-dg-color-white);
  padding: var(--string-dg-panel-padding);
  border-radius: var(--string-dg-panel-radius);
  box-shadow: var(--string-dg-panel-shadow);
}
[data-stdg-panel][data-open="false"] {
  opacity: 0;
  pointer-events: none;
  transform: translateY(4px);
  transition: opacity 0.15s ease, transform 0.15s ease;
}
[data-stdg-panel][data-open="true"] {
  z-index: 10045;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
  transition: opacity 0.15s ease, transform 0.15s ease;
}
[data-stdg-panel][data-test-panel-1] {
  top: 0px;
  right: calc(100% + 20px);
}
[data-stdg-panel][data-test-panel-2] {
  top: 0;
  right: calc(100% + 20px + 220px + 80px);
}
[data-stdg-panel][data-test-panel-3] {
  top: 0;
  right: calc(100% + 20px);
}

[data-stdg-panel][data-test-panel-4] {
  top: 0;
  right: calc(100% + 20px + 220px + 80px + 220px + 20px + 220px + 80px);
}
[data-stdg-panel][data-test-panel-5] {
  top: 0;
  right: calc(100% + 20px);
}
[data-stdg-panel][data-test-panel-6] {
  top: calc(400px);
  right: calc(100% + 20px);
}
[data-stdg-panel][data-test-panel-7] {
  top: calc(36px);
  right: calc(100% + 20px);
}

/* progress */
[data-stdg-progress] {
  position: fixed;
  z-index: 999;
  bottom: 62px;
  left: calc((100vw + env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px)) / 2);
  translate: -50% 0;

  width: min(
    440px,
    calc(100vw - 24px - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px))
  );
  max-height: calc(100vh - 86px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px));
  overflow: hidden auto;
  overscroll-behavior: contain;
}

[data-stdg-panel-hr] {
  display: block;
  margin: var(--string-dg-panel-hr-margin);
  border-bottom: 1px solid var(--string-dg-color-grey-1);
}
/* header */
[data-stdg-panel-header] {
  display: grid;
  place-items: center;
  padding: var(--string-dg-panel-header-padding);
}
[data-stdg-panel-header] > * {
  grid-area: 1/1;
}
[data-stdg-button-left] {
  justify-self: start;
}
[data-stdg-button-right] {
  justify-self: end;
}
[data-stdg-panel-header] span {
  font-size: var(--string-dg-font-size-s);
  font-weight: var(--string-dg-font-bold);
}
[data-stdg-panel-header] nav {
  display: flex;
}

/* responsive */
[data-stdg-panel-responsive] {
  display: grid;
  place-items: center;
  padding: var(--string-dg-panel-responsive-margin);
}
[data-stdg-panel-responsive] > * {
  grid-area: 1/1;
}
[data-stdg-panel-list] {
  display: flex;
  flex-direction: row;
}

/* content */
[data-stdg-panel-content] {
  margin: var(--string-dg-panel-conent-margin);
}
[data-stdg-panel-content-50] {
  display: flex;
  flex-wrap: wrap;
}
[data-stdg-panel-content-50] > * {
  width: 50% !important;
}

/* list-item */

/* offsets */
[data-stdg-offsets-item] {
  position: absolute;
  z-index: 999;
  top: 600px;
  left: 260px;

  width: 400px;
  height: 400px;
  fill: none;
  overflow: visible;
}
[data-stdg-offsets-item] [data-stdg-offsets-item-border] {
  stroke-width: 1px;
  stroke: var(--string-dg-color-offset);
  stroke-dasharray: var(--string-dg-offsets-dasharray);
}
[data-stdg-offsets-item-offset] {
}
[data-stdg-offsets-item-offset-arrow-bg] {
  color: var(--string-dg-color-white);
}
[data-stdg-offsets-item-offset-arrow] {
  color: var(--string-dg-color-black);
}

`;
